import React, { useEffect } from 'react';
import { SidebarNavigation } from './SidebarNavigation';
import { Navigation } from './Navigation';
import { MobileGestureContainer } from './mobile/MobileGestureContainer';
import { MobileBottomNavigation } from './mobile/MobileBottomNavigation';
import { useEnhancedMobile } from '@/hooks/use-enhanced-mobile';

interface LayoutProps {
  children: React.ReactNode;
  onRefresh?: () => Promise<void> | void;
}

export const Layout: React.FC<LayoutProps> = ({ children, onRefresh }) => {
  const { isMobile } = useEnhancedMobile();

  // Register service worker for PWA
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js')
        .then(registration => {
          console.log('SW registered: ', registration);
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    }
  }, []);

  // Mobile layout - uses existing mobile navigation
  if (isMobile) {
    return (
      <div className="min-h-screen bg-background">
        <Navigation />
        <MobileGestureContainer onRefresh={onRefresh}>
          <main className="overflow-x-hidden max-w-full pt-14 pb-20 safe-area-bottom">
            {children}
          </main>
        </MobileGestureContainer>
        <MobileBottomNavigation />
      </div>
    );
  }

  // Desktop layout - uses new sidebar navigation
  return (
    <div className="min-h-screen bg-background flex">
      <SidebarNavigation />
      <main className="flex-1 ml-16 overflow-x-hidden">
        {children}
      </main>
    </div>
  );
};